<div class="knowledge-base-page">
    @if (loadError) {
      <p class="kb2-load-error">{{ loadError }}</p>
    }
  
    @if (!loadError) {
      <div id="view-knowledge-base" class="kb2">
        <div class="kb2-search-wrap">
          <div class="kb2-search-inner">
            <span class="kb2-search-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            </span>
            <div
              class="kb2-search-input-wrap"
              [class.has-value]="searchQuery.trim().length > 0"
              [class.is-focused]="searchInputFocused"
            >
              <span class="kb2-search-placeholder" aria-hidden="true">
                <span class="kb2-search-placeholder-label">AI Search</span>
                <span class="kb2-search-placeholder-sep" aria-hidden="true"></span>
                <span class="kb2-search-placeholder-tagline">Ask us anything</span>
              </span>
              <input
                type="search"
                class="kb2-search-input"
                placeholder=" "
                aria-label="AI Search - Ask us anything"
                autocomplete="off"
                [ngModel]="searchQuery"
                (ngModelChange)="onSearchInput($event)"
                (keydown.enter)="submitSearch(); $event.preventDefault()"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
              />
              @if (searchQuery.trim().length > 0) {
                <button
                  type="button"
                  class="kb2-search-clear"
                  aria-label="Clear search"
                  (click)="clearSearch()"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>
                </button>
              }
            </div>
            <button type="button" class="kb2-search-submit" aria-label="Search" (click)="submitSearch()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
          </div>
        </div>
  
        @if (aiLoading || lastAiQuery.trim().length > 0) {
          <div class="kb2-ai-inline" role="region" aria-label="AI answer" id="kb2-ai-answer-region">
            <p class="kb2-search-query-display" aria-live="polite">
              @if (aiLoading) {
                Searching for: "{{ lastAiQuery }}"
              } @else if (!aiError) {
                Results for: "{{ lastAiQuery }}"
              } @else {
                Search for: "{{ lastAiQuery }}"
              }
            </p>
            @if (aiLoading) {
              <div class="kb2-ai-loading">Searching…</div>
            }
            @if (aiError) {
              <div class="kb2-ai-error">{{ aiError }}</div>
            }
            @if (!aiLoading && !aiError) {
              <div class="kb2-ai-card kb2-ai-card--summary">
                <h2 class="kb2-ai-card__title">Answer</h2>
                <div class="kb2-ai-summary markdown-body" [innerHTML]="aiSummaryHtml"></div>
              </div>
            }
            <p class="kb2-ai-disclaimer" role="note">
              <span class="kb2-ai-disclaimer__label">NOTE:</span> AI responses may contain inaccuracies.
            </p>
          </div>
        }
  
        @if (view === 'home') {
          <div class="kb2-home">
            <h2 class="kb2-hero-title">How can we assist you?</h2>
            <p class="kb2-hero-sub">
              Find answers and learn about Danlaw DataLogger products and the BitBrew platform.
            </p>
            <div class="kb2-cards">
              @for (group of cardGroups; track group.title) {
                <h3 class="kb2-cards-group-title">{{ group.title }}</h3>
                @for (idx of group.sectionIndices; track idx) {
                  @if (sections[idx]; as sec) {
                    <a href="#" class="kb2-card" (click)="openSection(idx); $event.preventDefault()">
                      <span class="kb2-card-icon" aria-hidden="true" [innerHTML]="cardIconSvg(sec)"></span>
                      <span class="kb2-card-title">{{ sec.title }}</span>
                      <p class="kb2-card-desc">{{ cardDescription(sec) }}</p>
                    </a>
                  }
                }
              }
            </div>
          </div>
        }
  
        @if (view === 'section' && currentSection && sectionIndex !== null) {
          <div class="kb2-section-view">
            <nav class="kb2-breadcrumb" aria-label="Breadcrumb">
              <a href="#" class="kb2-breadcrumb-link" data-kb2-back (click)="openHome(); $event.preventDefault()">Back to Knowledge Base</a>
              <span class="kb2-breadcrumb-sep" aria-hidden="true">/</span>
              <span class="kb2-breadcrumb-current">{{ currentSection.title }}</span>
            </nav>
            <div class="kb2-section-layout">
              <aside class="kb2-sidenav">
                <ul class="kb2-sidenav-list">
                  @if (currentSection.subsections?.length) {
                    @for (sub of currentSection.subsections; let subIdx = $index; track sub.title) {
                      @if (sub.subsections?.length) {
                        <li
                          class="kb2-sidenav-item kb2-sidenav-accordion"
                          [class.is-expanded]="isAccordionExpanded(accordionKey(subIdx, 'nested'))"
                        >
                          <button
                            type="button"
                            class="kb2-sidenav-accordion-trigger"
                            [attr.aria-expanded]="isAccordionExpanded(accordionKey(subIdx, 'nested'))"
                            (click)="toggleAccordion(accordionKey(subIdx, 'nested'))"
                          >
                            <span class="kb2-sidenav-accordion-label">{{ sub.title }}</span>
                            <span class="kb2-sidenav-accordion-icon" aria-hidden="true">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
                            </span>
                          </button>
                          <div class="kb2-sidenav-accordion-panel">
                            @for (nested of sub.subsections; let nestedIdx = $index; track nested.title) {
                              <span class="kb2-sidenav-group-label kb2-sidenav-accordion-sublabel">{{ nested.title }}</span>
                              <ul class="kb2-sidenav-sublist">
                                @for (art of nested.articles; let artIdx = $index; track art.q) {
                                  <li class="kb2-sidenav-item">
                                    <a
                                      href="#"
                                      class="kb2-sidenav-link kb2-sidenav-sublink"
                                      [class.is-active]="isLinkActive(subIdx, artIdx, nestedIdx)"
                                      (click)="onSidenavLink(sectionIndex, subIdx, artIdx, nestedIdx); $event.preventDefault()"
                                    >{{ art.q }}</a>
                                  </li>
                                }
                              </ul>
                            }
                          </div>
                        </li>
                      } @else if (sub.articles?.length === 1) {
                        <li class="kb2-sidenav-item">
                          <a
                            href="#"
                            class="kb2-sidenav-link"
                            [class.is-active]="isLinkActive(subIdx, 0)"
                            (click)="onSidenavLink(sectionIndex, subIdx, 0); $event.preventDefault()"
                          >{{ sub.title }}</a>
                        </li>
                      } @else {
                        <li
                          class="kb2-sidenav-item kb2-sidenav-accordion"
                          [class.is-expanded]="isAccordionExpanded(accordionKey(subIdx, 'multi'))"
                        >
                          <button
                            type="button"
                            class="kb2-sidenav-accordion-trigger"
                            [attr.aria-expanded]="isAccordionExpanded(accordionKey(subIdx, 'multi'))"
                            (click)="toggleAccordion(accordionKey(subIdx, 'multi'))"
                          >
                            <span class="kb2-sidenav-accordion-label">{{ sub.title }}</span>
                            <span class="kb2-sidenav-accordion-icon" aria-hidden="true">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
                            </span>
                          </button>
                          <div class="kb2-sidenav-accordion-panel">
                            <ul class="kb2-sidenav-sublist">
                              @for (art of sub.articles; let artIdx = $index; track art.q) {
                                <li class="kb2-sidenav-item">
                                  <a
                                    href="#"
                                    class="kb2-sidenav-link kb2-sidenav-sublink"
                                    [class.is-active]="isLinkActive(subIdx, artIdx)"
                                    (click)="onSidenavLink(sectionIndex, subIdx, artIdx); $event.preventDefault()"
                                  >{{ art.q }}</a>
                                </li>
                              }
                            </ul>
                          </div>
                        </li>
                      }
                    }
                  } @else if (currentSection.articles?.length) {
                    <li
                      class="kb2-sidenav-item kb2-sidenav-accordion"
                      [class.is-expanded]="isAccordionExpanded('flat')"
                    >
                      <button
                        type="button"
                        class="kb2-sidenav-accordion-trigger"
                        [attr.aria-expanded]="isAccordionExpanded('flat')"
                        (click)="toggleAccordion('flat')"
                      >
                        <span class="kb2-sidenav-accordion-label">{{ currentSection.title }}</span>
                        <span class="kb2-sidenav-accordion-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
                        </span>
                      </button>
                      <div class="kb2-sidenav-accordion-panel">
                        <ul class="kb2-sidenav-sublist">
                          @for (art of currentSection.articles; let artIdx = $index; track art.q) {
                            <li class="kb2-sidenav-item">
                              <a
                                href="#"
                                class="kb2-sidenav-link kb2-sidenav-sublink"
                                [class.is-active]="isLinkActive(undefined, artIdx)"
                                (click)="onSidenavLink(sectionIndex, undefined, artIdx); $event.preventDefault()"
                              >{{ art.q }}</a>
                              @if (art.subArticles?.length) {
                                <ul class="kb2-sidenav-sublist kb2-sidenav-article-children">
                                  @for (subArt of art.subArticles; let subArtIdx = $index; track subArt.q) {
                                    <li class="kb2-sidenav-item">
                                      <a
                                        href="#"
                                        class="kb2-sidenav-link kb2-sidenav-sublink"
                                        [class.is-active]="isLinkActive(undefined, artIdx, undefined, subArtIdx)"
                                        (click)="onSidenavLink(sectionIndex, undefined, artIdx, undefined, subArtIdx); $event.preventDefault()"
                                      >{{ subArt.q }}</a>
                                    </li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ul>
                      </div>
                    </li>
                  }
                </ul>
              </aside>
              <main class="kb2-section-content">
                @if (selectedArticle) {
                  <div class="kb2-article-detail">
                    <div class="kb2-article-view">
                      <h2 class="kb2-article-title">{{ selectedArticle.q }}</h2>
  
                      @if (selectedArticle.pdfUrl) {
                        <a
                          class="kb2-pdf-download"
                          [href]="pdfDownloadHref()"
                          [attr.download]="(selectedArticle.q || 'document') + '.pdf'"
                        >Download PDF</a>
                        <div class="kb2-pdf-wrap modal-pdf-wrap">
                          @if (pdfLoading) {
                            <div class="modal-pdf-loading">Loading PDF…</div>
                          }
                          @if (pdfError) {
                            <div class="modal-pdf-loading">{{ pdfError }}</div>
                          }
                          @if (pdfPreviewUrl && !pdfLoading && !pdfError) {
                            <iframe
                              class="kb2-pdf-iframe"
                              [src]="pdfPreviewUrl"
                              [title]="(selectedArticle.q || 'Document') + ' PDF preview'"
                            ></iframe>
                          }
                        </div>
                      } @else if (selectedArticle.kind === 'cable') {
                        <button
                          type="button"
                          class="kb2-copy-markdown"
                          [title]="copyMarkdownLabel"
                          [attr.aria-label]="copyMarkdownLabel"
                          (click)="copyText(cableMarkdown(selectedArticle), $event)"
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                        </button>
                        <dl class="kb2-cable-meta">
                          @if (selectedArticle.cableType) {
                            <dt>Type</dt>
                            <dd>{{ selectedArticle.cableType }}</dd>
                          }
                          @if (selectedArticle.partNumber) {
                            <dt>Part number</dt>
                            <dd class="kb2-cable-part-number">{{ selectedArticle.partNumber }}</dd>
                          }
                        </dl>
                        @if (selectedArticle.imageUrl) {
                          <figure class="kb2-cable-figure">
                            <img
                              class="kb2-cable-image"
                              [src]="selectedArticle.imageUrl"
                              [alt]="selectedArticle.cableType || selectedArticle.q"
                              loading="lazy"
                            />
                          </figure>
                        }
                        @if (selectedArticle.a?.trim()) {
                          <div class="kb2-article-body kb2-cable-body markdown-body" [innerHTML]="markdownHtml(selectedArticle.a)"></div>
                        }
                      } @else {
                        @if (selectedArticle.a?.trim() || (selectedArticle.blocks?.length ?? 0) > 0) {
                          <button
                            type="button"
                            class="kb2-copy-markdown"
                            [title]="copyMarkdownLabel"
                            [attr.aria-label]="copyMarkdownLabel"
                            (click)="copyText(articleMarkdownForCopy(selectedArticle), $event)"
                          >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                          </button>
                        }
                        <div class="kb2-article-body kb2-article-body--structured">
                          @for (slice of cachedArticleSlices; track $index) {
                            @if (slice.kind === 'markdown') {
                              <div class="markdown-body" [innerHTML]="markdownHtml(selectedArticle.a)"></div>
                            }
                            @if (slice.kind === 'blocks') {
                          @for (block of slice.items; let blockIdx = $index; track blockIdx) {
                            @if (block.type === 'specTable') {
                              <section class="kb2-content-block kb2-content-block--spec" [attr.aria-labelledby]="'kb2-spec-title-' + sectionIndex + '-' + blockIdx">
                                <h3 class="kb2-block-title" [id]="'kb2-spec-title-' + sectionIndex + '-' + blockIdx">{{ block.title }}</h3>
                                @if (block.releaseDate) {
                                  <p class="kb2-spec-table__release-date"><strong>Release date:</strong> {{ block.releaseDate }}</p>
                                }
                                <div class="kb2-table-shell">
                                  <table class="kb2-spec-table">
                                    <thead>
                                      <tr>
                                        <th scope="col">{{ block.headers?.[0] ?? 'Area' }}</th>
                                        <th scope="col">{{ block.headers?.[1] ?? 'Details' }}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (row of block.rows; track row.area) {
                                        <tr>
                                          <th scope="row" class="kb2-spec-table__area">{{ row.area }}</th>
                                          <td class="kb2-spec-table__details">
                                            <span class="kb2-inline-md" [innerHTML]="markdownInlineHtml(row.details)"></span>
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </section>
                            } @else if (block.type === 'dataTable') {
                              <section
                                class="kb2-content-block kb2-content-block--data"
                                [attr.aria-labelledby]="block.title ? ('kb2-data-title-' + sectionIndex + '-' + blockIdx) : null"
                              >
                                @if (block.title) {
                                  <h3 class="kb2-block-title" [id]="'kb2-data-title-' + sectionIndex + '-' + blockIdx">{{ block.title }}</h3>
                                }
                                <div class="kb2-table-shell kb2-table-shell--scroll">
                                  <table class="kb2-data-table">
                                    <thead>
                                      <tr>
                                        @for (col of block.columns; track col) {
                                          <th scope="col">{{ col }}</th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @if (block.groupedRows?.length) {
                                        @for (gr of expandedDataTableGroupRows(block); track gr.key) {
                                          <tr>
                                            @if (gr.groupLabel) {
                                              <td
                                                class="kb2-data-table__group"
                                                [attr.rowspan]="gr.groupRowspan"
                                              >
                                                <span class="kb2-data-table__group-text">{{ gr.groupLabel }}</span>
                                              </td>
                                            }
                                            @for (c of gr.cellItems; track c.id) {
                                              <td>
                                                <span class="kb2-inline-md" [innerHTML]="markdownInlineHtml(c.text)"></span>
                                              </td>
                                            }
                                          </tr>
                                        }
                                      } @else {
                                        @for (row of block.rows ?? []; let ri = $index; track ri) {
                                          <tr>
                                            @for (col of block.columns; let ci = $index; track col) {
                                              <td [class.kb2-data-table__name-tile]="ci === 0">
                                                <span class="kb2-inline-md" [innerHTML]="markdownInlineHtml(row[ci])"></span>
                                              </td>
                                            }
                                          </tr>
                                        }
                                      }
                                      @if (!(block.groupedRows?.length || (block.rows?.length ?? 0) > 0)) {
                                        <tr>
                                          <td [attr.colspan]="block.columns.length">No rows.</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </section>
                            }
                          }
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </main>
            </div>
          </div>
        }
  
        <div class="kb2-contact-card">
          <p class="kb2-contact-card__title">Still have questions?</p>
          <a [href]="contactMailto" class="kb2-contact-card__link">Contact Us</a>
        </div>
      </div>
    }
  </div>